var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.334 3.5a1 1 0 1 1 0 2 6 6 0 1 0 6 6 1 1 0 1 1 2 0c0 1.849-.63 3.549-1.683 4.903l3.39 3.39.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-3.39-3.39a7.96 7.96 0 0 1-4.903 1.683 8 8 0 1 1 0-16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.002 3.896a.354.354 0 0 1 .664 0c.435 1.175.651 1.763 1.08 2.192.429.428 1.017.645 2.192 1.08a.354.354 0 0 1 0 .664c-1.175.435-1.763.652-2.192 1.08-.428.429-.645 1.017-1.08 2.191a.354.354 0 0 1-.664 0c-.435-1.174-.652-1.762-1.08-2.19-.429-.43-1.017-.646-2.192-1.081a.354.354 0 0 1 0-.664c1.175-.435 1.763-.652 2.192-1.08.428-.429.645-1.017 1.08-2.192"
  })));
};
export default Svg24;